import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Select from "react-select";

import {
  OverlayTrigger,
  Tabs,
  Tab,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class ManufacturingTask extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      statusId: "1",
      seqNo: "",
    };
  }

  componentDidMount = () => {
    if (this.props.Type == "Edit") {
      this.setState({ taskName: this.props.manufacturingTask.taskName });
      this.setState({
        taskDescription: this.props.manufacturingTask.taskDescription,
      });
      this.setState({ assignedTo: this.props.manufacturingTask.assignedTo });
      this.setState({ statusId: this.props.manufacturingTask.statusId });
      this.setState({ seqNo: this.props.manufacturingTask.seqNo });
    }
    if (document.getElementById("taskName") != null)
      document.getElementById("taskName").focus();
  };

  handleItemsInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "taskName":
        this.setState({ taskName: value });
        break;
      case "taskDescription":
        this.setState({ taskDescription: value });
        break;
      case "assignedTo":
        this.setState({ assignedTo: value });
        break;
      case "statusId":
        this.setState({ statusId: value });
        break;
      case "seqNo":
        this.setState({ seqNo: value });
        break;
    }
  };
  handleSubmit = (event) => {
    if (
      this.state.taskName == "" ||
      this.state.assignedTo == "" ||
      this.state.statusId == ""
    ) {
      alert("enter all manadatory fields and try!");
      return;
    }
    if (this.props.Type == "Add") {
      this.props.AddManufacturingTask({
        taskName: this.state.taskName,
        taskDescription: this.state.taskDescription,
        seqNo: this.state.seqNo,
        assignedTo: this.state.assignedTo,
        statusId: this.state.statusId,
      });
    } else {
      this.props.UpdateManufacturingTask(
        {
          taskName: this.state.taskName,
          taskDescription: this.state.taskDescription,
          seqNo: this.state.seqNo,
          assignedTo: this.state.assignedTo,
          statusId: this.state.statusId,
        },
        this.props.Index
      );
    }
  };

  render() {
    return (
      <>
        <div className="container ">
          <Modal
            {...this.props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={true}
            backdrop="static"
            keyboard={false}
            dialogClassName="CouponModal"
          >
            {/* <Form onSubmit={this.handleSubmit}> */}
            {/* <Form> */}
            <Modal.Header closeButton className="bg-primary text-light">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit Manufacturing Item/Task"
                  : "Add Manufacturing Item/Task "}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row className="m-2 p-2 bg-light " style={{ fontSize: "12pt" }}>
                <Col md={12}>
                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Name (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        size="lg"
                        className="pd-2 w-100"
                        name="taskName"
                        id="taskName"
                        required
                        value={this.state.taskName}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Description
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        as="textarea"
                        type="textarea"
                        rows={3}
                        maxLength={1999}
                        size="lg"
                        className="pd-2 w-100"
                        name="taskDescription"
                        required
                        value={this.state.taskDescription}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Assigned To (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        size="lg"
                        className="pd-2 w-100"
                        name="assignedTo"
                        required
                        value={this.state.assignedTo}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      >
                        <option value=""></option>
                        {this.props.users.map((d) => (
                          <>
                            {d.emailId == "productsupport" ? (
                              <></>
                            ) : (
                              <>
                                <option value={d.id}>{d.emailId}</option>
                              </>
                            )}
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Status (*)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        size="lg"
                        className="pd-2 w-100"
                        name="statusId"
                        required
                        value={this.state.statusId}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      >
                        <option value="1">Open</option>
                        <option value="2">InProgress</option>
                        <option value="3">Complete</option>
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                {/* <Button variant="primary" size="lg" type="submit"> */}
                <Button variant="primary" size="lg" onClick={this.handleSubmit}>
                  {this.props.Type == "Add" ? "Add" : "Update"}
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
            {/* </Form> */}
          </Modal>
        </div>
      </>
    );
  }
}
